module.exports = __webpack_public_path__ + "img/domain-02-mobile.394015b4.png";